import axios from "axios";

const API = axios.create({
  baseURL: "https://thesalonx.in/api",
});

// ✅ Attach token + Accept header
API.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  config.headers["Accept"] = "application/json";

  return config;
});

// ✅ Handle token expiry
API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("token");
      window.dispatchEvent(new Event("logout"));
    }
    return Promise.reject(error);
  }
);

export default API;